const nadiSafeEvents = {
  "schema_version": "1.0",
  "policy_profile": "Conservative public-facing astrology content for Apple App Store and Google Play",
  "policy_review_date": "2026-08-23",
  "display_rules": {
    "prefix_style": "Present results as traditional astrological indications, tendencies or possibilities.",
    "recommended_terms": [
      "may indicate",
      "supportive indicators",
      "challenging indicators",
      "prospects",
      "potential",
      "tendency",
      "traditional Nadi association"
    ],
    "avoid_terms": [
      "confirmed",
      "guaranteed",
      "100%",
      "definitely",
      "will happen",
      "cannot happen",
      "no chance",
      "certain"
    ],
    "public_disclaimer": "These interpretations are based on traditional astrological principles and are intended for informational and educational purposes. They indicate tendencies and possibilities, not guaranteed outcomes. For legal, financial, medical or other professional matters, consult an appropriately qualified professional."
  },
  "categories": [
    {
      "id": "career_work_business",
      "name": "Career, Work & Business",
      "events": [
        {
          "id": "employment_prospects",
          "source_ids": [
            3
          ],
          "name": "Employment Prospects",
          "polarity": "positive",
          "combinations": [
            "2,6,10,11"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "business_prospects",
          "source_ids": [
            4
          ],
          "name": "Business Prospects",
          "polarity": "positive",
          "combinations": [
            "2,7,10,11"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "earning_potential",
          "source_ids": [
            4
          ],
          "name": "Earning Potential",
          "polarity": "positive",
          "combinations": [
            "2,6,10,11",
            "2,6,11",
            "6,11",
            "6,10,11",
            "2,11",
            "2,6,10",
            "6,10",
            "6",
            "2,6",
            "2"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [],
          "notes": [
            "Source gives different strengths of earning support.",
            "Strong group: 2,6,10,11 = 2,6,11 = 6,11 = 6,10,11 > 2,11.",
            "Additional progression: 2,6,10 > 6,10 > 6 > 2; 2,6 is an earning indicator and 2 is a weaker possible earning indicator."
          ]
        },
        {
          "id": "business_challenges",
          "source_ids": [
            5
          ],
          "name": "Business Challenges",
          "polarity": "challenging",
          "combinations": [
            "6,8,12",
            "5,8,12"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [],
          "notes": [
            "Source treats 5,8,12 as the stronger loss/challenge combination."
          ]
        },
        {
          "id": "business_recovery",
          "source_ids": [
            5
          ],
          "name": "Business Recovery Indicators",
          "polarity": "positive",
          "combinations": [
            "6,8,12 + 10,11",
            "5,8,12 + 10,11"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [
            "10,11 acts as regain/recovery support after business difficulty."
          ],
          "notes": []
        },
        {
          "id": "administration_career",
          "source_ids": [
            38
          ],
          "name": "Administration Career",
          "polarity": "positive",
          "combinations": [
            "6,10,11"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "employment_challenges",
          "source_ids": [
            39
          ],
          "name": "Employment Challenges",
          "polarity": "challenging",
          "combinations": [
            "5,8,12"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "professional_obstacles",
          "source_ids": [
            40
          ],
          "name": "Professional Obstacles / Delays",
          "polarity": "challenging",
          "combinations": [
            "8"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "professional_recognition_challenges",
          "source_ids": [
            41
          ],
          "name": "Professional Recognition Challenges",
          "polarity": "challenging",
          "combinations": [
            "12"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "financial_pressure",
          "source_ids": [
            42
          ],
          "name": "Financial Pressure",
          "polarity": "challenging",
          "combinations": [
            "12"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "financial_return_cycle",
          "source_ids": [
            45
          ],
          "name": "Financial Return Cycle",
          "polarity": "positive",
          "combinations": [
            "12,11"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [],
          "notes": [
            "Use only as an astrological financial trend; do not present as investment advice or guaranteed return."
          ]
        },
        {
          "id": "supportive_career_change",
          "source_ids": [
            46
          ],
          "name": "Supportive Career Change",
          "polarity": "positive",
          "combinations": [
            "5,9"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "favourable_career_transition",
          "source_ids": [
            47
          ],
          "name": "Favourable Career Transition",
          "polarity": "positive",
          "combinations": [
            "2,6,10,11"
          ],
          "planets": [],
          "conditions": [
            "Next DBA"
          ],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "challenging_career_transition",
          "source_ids": [
            48
          ],
          "name": "Challenging Career Transition",
          "polarity": "challenging",
          "combinations": [
            "5,8,12",
            "6,12",
            "6,8,12"
          ],
          "planets": [],
          "conditions": [
            "Next DBA"
          ],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "workplace_transfer",
          "source_ids": [
            49
          ],
          "name": "Workplace Transfer / Relocation",
          "polarity": "neutral",
          "combinations": [
            "9,3,12"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "return_previous_workplace",
          "source_ids": [
            50
          ],
          "name": "Return to Previous Workplace / Location",
          "polarity": "positive",
          "combinations": [
            "2,4,11"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [],
          "notes": []
        }
      ]
    },
    {
      "id": "personality_temperament",
      "name": "Personality & Temperament",
      "events": [
        {
          "id": "assertive_temperament",
          "source_ids": [
            6
          ],
          "name": "Assertive / Intense Temperament",
          "polarity": "neutral",
          "combinations": [
            "7,8,12"
          ],
          "planets": [
            {
              "name": "Mars",
              "role": "modifier",
              "condition": "Mars connected with the 1st or 3rd house"
            }
          ],
          "conditions": [],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "emotional_sensitivity",
          "source_ids": [
            7
          ],
          "name": "Emotional Sensitivity",
          "polarity": "neutral",
          "combinations": [
            "1,2,6,8,12"
          ],
          "planets": [
            {
              "name": "Moon",
              "role": "modifier",
              "condition": "Moon influence; source also notes Cancer connected with the 1st house"
            }
          ],
          "conditions": [],
          "modifiers": [],
          "notes": [
            "Do not label this as depression or another mental-health diagnosis."
          ]
        },
        {
          "id": "affectionate_nature",
          "source_ids": [
            8
          ],
          "name": "Affectionate & Relationship-Oriented Nature",
          "polarity": "positive",
          "combinations": [
            "2,7,11"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "warm_supportive_nature",
          "source_ids": [
            9
          ],
          "name": "Warm & Supportive Nature",
          "polarity": "positive",
          "combinations": [
            "5,9,11"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "independent_detached_tendencies",
          "source_ids": [
            10
          ],
          "name": "Independent / Detached Tendencies",
          "polarity": "neutral",
          "combinations": [
            "1,6,10"
          ],
          "planets": [
            {
              "name": "Rahu",
              "role": "associated planet"
            },
            {
              "name": "Ketu",
              "role": "associated planet"
            },
            {
              "name": "Saturn",
              "role": "associated planet"
            },
            {
              "name": "Sun",
              "role": "associated planet"
            }
          ],
          "conditions": [],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "reserved_practical_nature",
          "source_ids": [
            11
          ],
          "name": "Reserved / Practical Nature",
          "polarity": "neutral",
          "combinations": [
            "1,4,10"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "persistent_nature",
          "source_ids": [
            60
          ],
          "name": "Persistent / Determined Nature",
          "polarity": "positive",
          "combinations": [
            "5,10"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [],
          "notes": []
        }
      ]
    },
    {
      "id": "relationships_marriage",
      "name": "Relationships & Marriage",
      "category_modifiers": [
        {
          "id": "venus_neutral_modifier",
          "source_ids": [
            23
          ],
          "name": "Venus Neutral Modifier",
          "combination": "3,5,8",
          "planets": [
            {
              "name": "Venus",
              "role": "neutral/modifying factor"
            }
          ],
          "notes": [
            "Use as an internal relationship modifier, not a standalone prediction."
          ]
        }
      ],
      "events": [
        {
          "id": "relationship_boundary_challenges",
          "source_ids": [
            14
          ],
          "name": "Relationship Boundary Challenges",
          "polarity": "challenging",
          "combinations": [
            "5,8,12"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [],
          "notes": [
            "Do not label the user or partner as unfaithful."
          ]
        },
        {
          "id": "supportive_relationship_bond",
          "source_ids": [
            15
          ],
          "name": "Supportive Relationship Bond",
          "polarity": "positive",
          "combinations": [
            "5,9,11",
            "5,11"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "private_complex_relationship_phase",
          "source_ids": [
            16
          ],
          "name": "Private / Complex Relationship Phase",
          "polarity": "neutral",
          "combinations": [
            "5,9,11 + 4",
            "5,9,11 + 6"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [
            "Source also lists 5,9,11; 5,11; and 5,8,11 as cleaner/supportive relationship variants."
          ],
          "notes": []
        },
        {
          "id": "relationship_conflict_tendency",
          "source_ids": [
            18
          ],
          "name": "Relationship Conflict / Reactive Dynamics",
          "polarity": "challenging",
          "combinations": [
            "7,8,12"
          ],
          "planets": [
            {
              "name": "Mars",
              "role": "modifier"
            }
          ],
          "conditions": [],
          "modifiers": [],
          "notes": [
            "Keep wording non-violent; do not predict assault."
          ]
        },
        {
          "id": "marriage_prospects",
          "source_ids": [
            19
          ],
          "name": "Marriage Prospects",
          "polarity": "positive",
          "combinations": [
            "1,2,7,11"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "marriage_known_circle",
          "source_ids": [
            20
          ],
          "name": "Marriage Through Known Circle",
          "polarity": "positive",
          "combinations": [
            "1,2,7,11 + 3"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "supportive_marriage_circumstances",
          "source_ids": [
            21
          ],
          "name": "Supportive Marriage Circumstances",
          "polarity": "positive",
          "combinations": [
            "5,8,9,12"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [],
          "notes": [
            "Source notes that the remaining houses are neutral."
          ]
        },
        {
          "id": "marriage_delay",
          "source_ids": [
            24
          ],
          "name": "Marriage Delay Indicators",
          "polarity": "challenging",
          "combinations": [
            "1,6,10"
          ],
          "planets": [],
          "conditions": [
            "In DBA"
          ],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "emotional_distance",
          "source_ids": [
            25
          ],
          "name": "Emotional Distance in Relationship",
          "polarity": "challenging",
          "combinations": [
            "2,7,11 + 1,6,10"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "reconciliation_indicators",
          "source_ids": [
            26
          ],
          "name": "Reconciliation Indicators",
          "polarity": "positive",
          "combinations": [
            "5,9"
          ],
          "planets": [],
          "conditions": [
            "Use with the preceding relationship/separation combination."
          ],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "marital_transition",
          "source_ids": [
            27
          ],
          "name": "Marital Transition / Separation Indicators",
          "polarity": "challenging",
          "combinations": [
            "1,6,10"
          ],
          "planets": [],
          "conditions": [
            "In DBA"
          ],
          "modifiers": [],
          "notes": [
            "Never display as 'divorce confirmed'."
          ]
        },
        {
          "id": "reduced_marriage_support",
          "source_ids": [
            28
          ],
          "name": "Reduced Support for Marriage",
          "polarity": "challenging",
          "combinations": [
            "1,6,10"
          ],
          "planets": [],
          "conditions": [
            "Strengthens when 1,6,10 is repeated through multiple relevant planets/significators.",
            "Strengthens when the 7th cusp lord also signifies 1,6,10."
          ],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "relocation_after_marriage",
          "source_ids": [
            31
          ],
          "name": "Relocation After Marriage",
          "polarity": "neutral",
          "combinations": [
            "3,12 + 4"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "distant_unfamiliar_relocation",
          "source_ids": [
            32
          ],
          "name": "Relocation to a Distant / Unfamiliar Place",
          "polarity": "neutral",
          "combinations": [
            "3,4,12"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "nontraditional_relationship_pattern",
          "source_ids": [
            35
          ],
          "name": "Non-Traditional Relationship Pattern",
          "polarity": "neutral",
          "combinations": [
            "2,11"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [],
          "notes": [
            "Do not use the original sensitive relationship label."
          ]
        }
      ]
    },
    {
      "id": "education_learning",
      "name": "Education & Learning",
      "events": [
        {
          "id": "education_prospects",
          "source_ids": [
            36
          ],
          "name": "Education Prospects",
          "polarity": "positive",
          "combinations": [
            "1,4,9,11",
            "2,4,9,11"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "strong_education_potential",
          "source_ids": [
            37
          ],
          "name": "Strong Education Potential",
          "polarity": "positive",
          "combinations": [
            "2,4,5,9,11"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "management_professional_education",
          "source_ids": [
            37
          ],
          "name": "Management / Professional Higher Education Potential",
          "polarity": "positive",
          "combinations": [
            "2,4,5,9,11 + 10,11"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [],
          "notes": [
            "Source specifically mentions MBA as an example."
          ]
        }
      ]
    },
    {
      "id": "profession_indicators",
      "name": "Profession Indicators",
      "events": [
        {
          "id": "astrology_profession",
          "source_ids": [
            51
          ],
          "name": "Astrology / Astrologer",
          "polarity": "positive",
          "combinations": [
            "5,8,12"
          ],
          "planets": [
            {
              "name": "Mercury",
              "role": "profession modifier"
            },
            {
              "name": "Jupiter",
              "role": "profession modifier"
            },
            {
              "name": "Ketu",
              "role": "profession modifier"
            }
          ],
          "conditions": [],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "teacher_educator",
          "source_ids": [
            52
          ],
          "name": "Teacher / Educator",
          "polarity": "positive",
          "combinations": [
            "2,4,5,9,11"
          ],
          "planets": [
            {
              "name": "Mercury",
              "role": "profession modifier"
            }
          ],
          "conditions": [],
          "modifiers": [
            "Higher-education support: 1,2,4,9,11"
          ],
          "notes": []
        },
        {
          "id": "writer_professional_writing",
          "source_ids": [
            53
          ],
          "name": "Writer / Professional Writing",
          "polarity": "positive",
          "combinations": [
            "3,6,11",
            "3,10,11",
            "3,11"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "profession_income_support",
          "source_ids": [
            54
          ],
          "name": "Income Support Through Profession",
          "polarity": "positive",
          "combinations": [
            "11",
            "10,11"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [],
          "notes": [
            "Use as a modifier to another profession indicator."
          ]
        },
        {
          "id": "medical_healthcare_profession",
          "source_ids": [
            55
          ],
          "name": "Medical / Healthcare Profession",
          "polarity": "positive",
          "combinations": [
            "6,8,12"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [
            "Stronger professional quality: 5,9,11 + 6,8,12",
            "Professional success support: 6,8,12 + 10,11 OR +11 OR +9,11"
          ],
          "notes": [
            "This event is about profession only; never use it to diagnose the user."
          ]
        },
        {
          "id": "engineer",
          "source_ids": [
            56
          ],
          "name": "Engineer",
          "polarity": "positive",
          "combinations": [
            "4,8,11"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "scientist",
          "source_ids": [
            57
          ],
          "name": "Scientist",
          "polarity": "positive",
          "combinations": [
            "2,4,5,9,11"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [],
          "notes": [
            "An additional 'C.A.' note in the source is ambiguous and is intentionally not used."
          ]
        },
        {
          "id": "research_inventions",
          "source_ids": [
            58
          ],
          "name": "Research / Inventions / Deep Analysis",
          "polarity": "positive",
          "combinations": [
            "8,12"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "recognition_through_innovation",
          "source_ids": [
            59
          ],
          "name": "Recognition Through Research / Innovation",
          "polarity": "positive",
          "combinations": [
            "8,12 + 5,9,10,11"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "information_technology",
          "source_ids": [
            61
          ],
          "name": "Information Technology",
          "polarity": "positive",
          "combinations": [
            "3,5,8"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [
            "Higher-education support: 2,4,5,9,11"
          ],
          "notes": []
        },
        {
          "id": "legal_profession",
          "source_ids": [
            62
          ],
          "name": "Lawyer / Legal Profession",
          "polarity": "positive",
          "combinations": [
            "6,8,12"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "architect",
          "source_ids": [
            63
          ],
          "name": "Architect",
          "polarity": "positive",
          "combinations": [
            "2,4,11 + 5 + 3"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "builder_construction",
          "source_ids": [
            64
          ],
          "name": "Builder / Construction",
          "polarity": "positive",
          "combinations": [
            "4,11,12"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "property_professional",
          "source_ids": [
            65
          ],
          "name": "Property / Real-Estate Professional",
          "polarity": "positive",
          "combinations": [
            "2,4,11 + 12 + 3,5,10"
          ],
          "planets": [
            {
              "name": "Mercury",
              "role": "profession modifier"
            }
          ],
          "conditions": [],
          "modifiers": [
            "Property purchase activity: 4,11,12",
            "Property sale activity: 3,5,10 with Saturn and Mars"
          ],
          "notes": []
        },
        {
          "id": "interior_designer",
          "source_ids": [
            66
          ],
          "name": "Interior Designer / Decorator",
          "polarity": "positive",
          "combinations": [
            "5,11"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "creativity_innovation",
          "source_ids": [
            67
          ],
          "name": "Creativity / Innovation",
          "polarity": "positive",
          "combinations": [
            "8,12"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "public_leadership_politics",
          "source_ids": [
            68
          ],
          "name": "Politics / Public Leadership",
          "polarity": "positive",
          "combinations": [
            "1,10,11",
            "1,9,10,11",
            "1,5,10,11"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "chartered_accountant",
          "source_ids": [
            70
          ],
          "name": "Chartered Accountant",
          "polarity": "positive",
          "combinations": [
            "2,4,9,11"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "data_management_business",
          "source_ids": [
            71
          ],
          "name": "Data Management / Business Management",
          "polarity": "positive",
          "combinations": [
            "3,11",
            "10,11"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "chef_culinary",
          "source_ids": [
            72
          ],
          "name": "Chef / Culinary Profession",
          "polarity": "positive",
          "combinations": [
            "5,8,9,11"
          ],
          "planets": [
            {
              "name": "Benefic planet",
              "role": "profession modifier",
              "condition": "Benefic in the 2nd house or beneficially aspecting/influencing the 2nd house"
            }
          ],
          "conditions": [],
          "modifiers": [
            "International / continental cuisine: +9,3,12"
          ],
          "notes": []
        },
        {
          "id": "correctional_institutional_admin",
          "source_ids": [
            73
          ],
          "name": "Correctional / Institutional Administration",
          "polarity": "positive",
          "combinations": [
            "10,11,2,3,8,12"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "journalist",
          "source_ids": [
            74
          ],
          "name": "Journalist / Media Professional",
          "polarity": "positive",
          "combinations": [
            "3,10,11",
            "3,11",
            "3,10"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [
            "Investigative / crime reporting: +7,8,12",
            "Political reporting: +1,10,11",
            "Sports reporting: +5,10"
          ],
          "notes": []
        },
        {
          "id": "creative_writer",
          "source_ids": [
            75
          ],
          "name": "Creative Writer",
          "polarity": "positive",
          "combinations": [
            "3,11"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [
            "Creativity: +5,9",
            "Artistic writing: 5,11",
            "Mystery / occult / deep subjects: 8,12"
          ],
          "notes": []
        }
      ]
    },
    {
      "id": "legal_matters",
      "name": "Legal Matters",
      "events": [
        {
          "id": "legal_dispute_indicators",
          "source_ids": [
            76
          ],
          "name": "Legal Dispute Indicators",
          "polarity": "challenging",
          "combinations": [
            "6,8,12"
          ],
          "planets": [
            {
              "name": "Rahu",
              "role": "associated planet"
            },
            {
              "name": "Ketu",
              "role": "associated planet"
            },
            {
              "name": "Saturn",
              "role": "associated planet"
            }
          ],
          "conditions": [],
          "modifiers": [],
          "notes": [
            "The source also contains a violent Mars modifier; that modifier is intentionally excluded from the public schema."
          ]
        },
        {
          "id": "supportive_legal_outcome",
          "source_ids": [
            77
          ],
          "name": "Supportive Legal Matter Indicators",
          "polarity": "positive",
          "combinations": [
            "1,6,10,11"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [],
          "notes": [
            "Do not guarantee a legal result."
          ]
        },
        {
          "id": "challenging_legal_outcome",
          "source_ids": [
            78
          ],
          "name": "Challenging Legal Matter Indicators",
          "polarity": "challenging",
          "combinations": [
            "6,8,12"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "legal_relief",
          "source_ids": [
            82
          ],
          "name": "Legal Relief Indicators",
          "polarity": "positive",
          "combinations": [
            "10,11",
            "6,11"
          ],
          "planets": [],
          "conditions": [
            "In DBA"
          ],
          "modifiers": [
            "5,9 acts as a facilitator."
          ],
          "notes": []
        }
      ]
    },
    {
      "id": "property_residence",
      "name": "Property & Residence",
      "category_modifiers": [
        {
          "id": "property_characteristics_by_planet",
          "name": "Traditional Property Characteristics by Planet",
          "source_ids": [
            95
          ],
          "items": [
            {
              "planet": "Saturn",
              "safe_meaning": "May indicate surroundings or maintenance needing greater attention."
            },
            {
              "planet": "Rahu",
              "safe_meaning": "May indicate surroundings or maintenance needing greater attention."
            },
            {
              "planet": "Ketu",
              "safe_meaning": "May indicate surroundings or maintenance needing greater attention; source also associates Ketu with first/upper floors."
            },
            {
              "planet": "Mercury",
              "safe_meaning": "May indicate a smaller property/house."
            },
            {
              "planet": "Jupiter",
              "safe_meaning": "May indicate a larger property; source also notes possible finishing/woodwork concerns."
            },
            {
              "planet": "Sun",
              "safe_meaning": "May indicate a larger property; with Moon, may indicate government/institutional property."
            },
            {
              "planet": "Moon",
              "safe_meaning": "With Sun, may indicate government/institutional property."
            }
          ]
        }
      ],
      "events": [
        {
          "id": "property_purchase",
          "source_ids": [
            85
          ],
          "name": "Property Purchase Prospects",
          "polarity": "positive",
          "combinations": [
            "4,11,12"
          ],
          "planets": [
            {
              "name": "Mars",
              "role": "property modifier",
              "condition": "Source notes aspect, transit, conjunction and DBA involvement"
            },
            {
              "name": "Saturn",
              "role": "property modifier",
              "condition": "Source notes aspect, transit, conjunction and DBA involvement"
            }
          ],
          "conditions": [],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "property_through_loan",
          "source_ids": [
            86
          ],
          "name": "Property Through Financing / Loan",
          "polarity": "positive",
          "combinations": [
            "4,11,12 + 6"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [
            "Loan repayment/completion support: +4,11"
          ],
          "notes": []
        },
        {
          "id": "property_through_support",
          "source_ids": [
            87
          ],
          "name": "Property Through Institutional / Personal Support",
          "polarity": "positive",
          "combinations": [
            "4,11,12 + 8"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [],
          "notes": [
            "Source examples: LIC, PF or friend's help."
          ]
        },
        {
          "id": "property_through_gift_inheritance",
          "source_ids": [
            88
          ],
          "name": "Property Through Gift / Inheritance",
          "polarity": "positive",
          "combinations": [
            "4,8,11"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "property_in_stages",
          "source_ids": [
            89
          ],
          "name": "Property Purchase in Stages",
          "polarity": "neutral",
          "combinations": [
            "4,12"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "government_allotted_property",
          "source_ids": [
            90
          ],
          "name": "Government / Institution-Allotted Property",
          "polarity": "positive",
          "combinations": [
            "4,11,12"
          ],
          "planets": [
            {
              "name": "Sun",
              "role": "modifier"
            },
            {
              "name": "Moon",
              "role": "modifier"
            }
          ],
          "conditions": [],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "commercial_property_purchase",
          "source_ids": [
            91
          ],
          "name": "Commercial Property Purchase",
          "polarity": "positive",
          "combinations": [
            "4,11,12 + 7"
          ],
          "planets": [
            {
              "name": "Mars",
              "role": "modifier"
            },
            {
              "name": "Saturn",
              "role": "modifier"
            },
            {
              "name": "Mercury",
              "role": "modifier"
            }
          ],
          "conditions": [],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "rental_income",
          "source_ids": [
            92
          ],
          "name": "Rental Income Potential",
          "polarity": "positive",
          "combinations": [
            "4,6,11"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [],
          "notes": [
            "Present as an astrological tendency, not guaranteed income."
          ]
        },
        {
          "id": "considering_residence_change",
          "source_ids": [
            93
          ],
          "name": "Considering a Residence Change",
          "polarity": "neutral",
          "combinations": [
            "4,11,12 + 5,9"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "change_of_residence",
          "source_ids": [
            94
          ],
          "name": "Change of Residence",
          "polarity": "neutral",
          "combinations": [
            "4,11,12 + 3,5"
          ],
          "planets": [
            {
              "name": "Separative planets",
              "role": "modifier"
            }
          ],
          "conditions": [],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "property_family_marriage_arrangement",
          "source_ids": [
            95
          ],
          "name": "Property Through Family / Marriage Arrangement",
          "polarity": "positive",
          "combinations": [
            "4,8,11 + 2,7,11"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "property_ownership_challenges",
          "source_ids": [
            96
          ],
          "name": "Property Ownership / Possession Challenges",
          "polarity": "challenging",
          "combinations": [
            "4,7,8,12"
          ],
          "planets": [
            {
              "name": "Rahu",
              "role": "modifier"
            },
            {
              "name": "Ketu",
              "role": "modifier"
            }
          ],
          "conditions": [],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "property_conflict_government_intervention",
          "source_ids": [
            97
          ],
          "name": "Property Conflict / Government Intervention",
          "polarity": "challenging",
          "combinations": [
            "7,8,12"
          ],
          "planets": [
            {
              "name": "Sun",
              "role": "modifier"
            },
            {
              "name": "Moon",
              "role": "modifier"
            }
          ],
          "conditions": [],
          "modifiers": [],
          "notes": [
            "Use non-violent wording; do not state that property will definitely be seized."
          ]
        },
        {
          "id": "property_litigation",
          "source_ids": [
            98
          ],
          "name": "Property Dispute / Litigation Indicators",
          "polarity": "challenging",
          "combinations": [
            "4,6,8,12"
          ],
          "planets": [
            {
              "name": "Rahu",
              "role": "modifier",
              "condition": "In DBA"
            },
            {
              "name": "Ketu",
              "role": "modifier",
              "condition": "In DBA"
            },
            {
              "name": "Venus",
              "role": "source modifier",
              "condition": "Do not infer gender in public UI"
            },
            {
              "name": "Mars",
              "role": "source modifier",
              "condition": "Do not infer gender in public UI"
            },
            {
              "name": "Jupiter",
              "role": "modifier",
              "condition": "With Mercury and a dual sign, source indicates repeated/multiple issues"
            },
            {
              "name": "Mercury",
              "role": "modifier",
              "condition": "With Jupiter and a dual sign, source indicates repeated/multiple issues"
            }
          ],
          "conditions": [],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "supportive_property_dispute_outcome",
          "source_ids": [
            99
          ],
          "name": "Supportive Property Dispute Indicators",
          "polarity": "positive",
          "combinations": [
            "6,11"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [],
          "notes": [
            "Do not guarantee a legal result."
          ]
        },
        {
          "id": "challenging_property_dispute_outcome",
          "source_ids": [
            99
          ],
          "name": "Challenging Property Dispute Indicators",
          "polarity": "challenging",
          "combinations": [
            "5,8,12"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "property_division",
          "source_ids": [
            100
          ],
          "name": "Property Division / Partition",
          "polarity": "neutral",
          "combinations": [
            "3,11"
          ],
          "planets": [
            {
              "name": "Mars",
              "role": "modifier"
            },
            {
              "name": "Saturn",
              "role": "modifier"
            },
            {
              "name": "Separative planets",
              "role": "modifier"
            }
          ],
          "conditions": [],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "property_sale",
          "source_ids": [
            101
          ],
          "name": "Property Sale Prospects",
          "polarity": "neutral",
          "combinations": [
            "3,5,10"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "favourable_property_sale_conditions",
          "source_ids": [
            102
          ],
          "name": "Favourable Property Sale Conditions",
          "polarity": "positive",
          "combinations": [
            "3,5,10 + 6,11"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "less_supportive_property_sale_conditions",
          "source_ids": [
            103
          ],
          "name": "Less Supportive Property Sale Conditions",
          "polarity": "challenging",
          "combinations": [
            "3,5,10 + 5,8,12",
            "3,5,10 + 6,8,12",
            "3,5,10 + 8,12"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [],
          "notes": []
        }
      ]
    },
    {
      "id": "vehicle",
      "name": "Vehicle",
      "category_modifiers": [
        {
          "id": "traditional_vehicle_colours",
          "name": "Traditionally Favoured Vehicle Colours",
          "source_ids": [
            105
          ],
          "items": [
            {
              "planet": "Sun",
              "colours": [
                "White",
                "Red",
                "Maroon"
              ]
            },
            {
              "planet": "Moon",
              "colours": [
                "White"
              ]
            },
            {
              "planet": "Mars",
              "colours": [
                "Red"
              ]
            },
            {
              "planet": "Mercury",
              "colours": [
                "Green"
              ]
            },
            {
              "planet": "Jupiter",
              "colours": [
                "Yellow"
              ]
            },
            {
              "planet": "Venus",
              "colours": [
                "White",
                "Metallic",
                "Fashionable/current shades"
              ]
            },
            {
              "planet": "Saturn",
              "colours": [
                "Dark Blue",
                "Black"
              ],
              "note": "Source also links Saturn with pre-owned vehicles."
            },
            {
              "planet": "Rahu",
              "colours": [
                "Blue",
                "Black"
              ]
            },
            {
              "planet": "Ketu",
              "colours": [
                "Red",
                "Sandalwood shades"
              ]
            }
          ]
        }
      ],
      "events": [
        {
          "id": "vehicle_acquisition",
          "source_ids": [
            "vehicle_heading"
          ],
          "name": "Vehicle Acquisition Prospects",
          "polarity": "positive",
          "combinations": [
            "4,11,12 + 3"
          ],
          "planets": [
            {
              "name": "Venus",
              "role": "primary vehicle significator"
            }
          ],
          "conditions": [],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "vehicle_through_loan",
          "source_ids": [
            104
          ],
          "name": "Vehicle Through Financing / Loan",
          "polarity": "positive",
          "combinations": [
            "4,6,11,12"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "vehicle_through_gift",
          "source_ids": [
            105
          ],
          "name": "Vehicle Through Gift",
          "polarity": "positive",
          "combinations": [
            "3,5,8,10,11"
          ],
          "planets": [
            {
              "name": "Venus",
              "role": "modifier",
              "condition": "Venus active in DBA"
            }
          ],
          "conditions": [],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "premium_vehicle",
          "source_ids": [
            106
          ],
          "name": "Premium / Luxury Vehicle Indicators",
          "polarity": "positive",
          "combinations": [
            "Venus + benefic aspect"
          ],
          "planets": [
            {
              "name": "Venus",
              "role": "primary factor"
            },
            {
              "name": "Natural benefic planets",
              "role": "aspecting/supporting factor"
            }
          ],
          "conditions": [],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "preowned_vehicle",
          "source_ids": [
            107
          ],
          "name": "Pre-Owned Vehicle Indicators",
          "polarity": "neutral",
          "combinations": [
            "Venus aspected by Rahu/Ketu/Saturn"
          ],
          "planets": [
            {
              "name": "Venus",
              "role": "primary factor"
            },
            {
              "name": "Rahu",
              "role": "aspecting factor"
            },
            {
              "name": "Ketu",
              "role": "aspecting factor"
            },
            {
              "name": "Saturn",
              "role": "aspecting factor"
            }
          ],
          "conditions": [],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "vehicle_maintenance_concerns",
          "source_ids": [
            108
          ],
          "name": "Vehicle Maintenance Concerns",
          "polarity": "challenging",
          "combinations": [
            "3,4,11,12 + 6,8,12"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "commercial_vehicle",
          "source_ids": [
            109
          ],
          "name": "Commercial Vehicle Indicators",
          "polarity": "positive",
          "combinations": [
            "4,11,12 + 7"
          ],
          "planets": [
            {
              "name": "Mercury",
              "role": "commercial vehicle modifier",
              "condition": "Mercury involved or aspecting"
            },
            {
              "name": "Venus",
              "role": "small commercial vehicle modifier",
              "condition": "Venus involved or aspecting"
            },
            {
              "name": "Saturn",
              "role": "heavy commercial vehicle modifier",
              "condition": "Saturn involved or aspecting"
            }
          ],
          "conditions": [],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "vehicle_security_caution",
          "source_ids": [
            110
          ],
          "name": "Vehicle Security / Possession Caution",
          "polarity": "challenging",
          "combinations": [
            "4,6,8,12"
          ],
          "planets": [
            {
              "name": "Saturn",
              "role": "modifier",
              "condition": "In DBA"
            },
            {
              "name": "Rahu",
              "role": "modifier",
              "condition": "In DBA"
            },
            {
              "name": "Ketu",
              "role": "modifier",
              "condition": "In DBA"
            }
          ],
          "conditions": [],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "strong_vehicle_security_caution",
          "source_ids": [
            111
          ],
          "name": "Strong Vehicle Security / Possession Caution",
          "polarity": "challenging",
          "combinations": [
            "4,6,8,12"
          ],
          "planets": [
            {
              "name": "Mars",
              "role": "modifier",
              "condition": "In DBA"
            },
            {
              "name": "Rahu",
              "role": "modifier",
              "condition": "In DBA"
            }
          ],
          "conditions": [],
          "modifiers": [],
          "notes": [
            "Do not predict theft/snatching as a certainty."
          ]
        },
        {
          "id": "vehicle_recovery_resolution",
          "source_ids": [
            112
          ],
          "name": "Vehicle Recovery / Resolution Indicators",
          "polarity": "positive",
          "combinations": [
            "2,6,10,11 + 4,11"
          ],
          "planets": [],
          "conditions": [
            "In DBA"
          ],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "vehicle_loan_repayment_challenge",
          "source_ids": [
            113
          ],
          "name": "Vehicle Loan Repayment Challenges",
          "polarity": "challenging",
          "combinations": [
            "4,6,8"
          ],
          "planets": [],
          "conditions": [
            "Stronger while the combination remains active in DBA"
          ],
          "modifiers": [
            "Improvement/return after payment: 4,6,11"
          ],
          "notes": []
        },
        {
          "id": "vehicle_sale",
          "source_ids": [
            114
          ],
          "name": "Vehicle Sale Prospects",
          "polarity": "neutral",
          "combinations": [
            "3,5,10"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "insurance_claim_support",
          "source_ids": [
            115
          ],
          "name": "Insurance Claim Indicators",
          "polarity": "positive",
          "combinations": [
            "8,11"
          ],
          "planets": [],
          "conditions": [
            "In DBA"
          ],
          "modifiers": [],
          "notes": [
            "Do not guarantee claim approval or payment."
          ]
        }
      ]
    },
    {
      "id": "travel_foreign",
      "name": "Travel, Visa & Foreign Matters",
      "events": [
        {
          "id": "general_travel",
          "source_ids": [
            "travel_heading"
          ],
          "name": "Travel Prospects",
          "polarity": "neutral",
          "combinations": [
            "3,9,12"
          ],
          "planets": [
            {
              "name": "Separative planets",
              "role": "travel modifier"
            }
          ],
          "conditions": [],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "short_distance_travel",
          "source_ids": [
            151
          ],
          "name": "Short-Distance Travel",
          "polarity": "neutral",
          "combinations": [
            "3,12"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "long_distance_travel",
          "source_ids": [
            152
          ],
          "name": "Long-Distance Travel",
          "polarity": "neutral",
          "combinations": [
            "3,9,12",
            "9,12"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "change_in_travel_plans",
          "source_ids": [
            153
          ],
          "name": "Change in Travel Plans / Route",
          "polarity": "neutral",
          "combinations": [
            "3,9,12 + 7"
          ],
          "planets": [
            {
              "name": "Separative planet",
              "role": "modifier"
            }
          ],
          "conditions": [],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "demanding_international_travel",
          "source_ids": [
            154
          ],
          "name": "International Travel Requiring Greater Adjustment",
          "polarity": "challenging",
          "combinations": [
            "3,9,12"
          ],
          "planets": [
            {
              "name": "Malefic planets",
              "role": "modifier"
            }
          ],
          "conditions": [],
          "modifiers": [],
          "notes": [
            "Do not classify destinations as developed/undeveloped."
          ]
        },
        {
          "id": "supportive_international_travel",
          "source_ids": [
            155
          ],
          "name": "Supportive International Travel",
          "polarity": "positive",
          "combinations": [
            "3,9,12"
          ],
          "planets": [
            {
              "name": "Benefic planets",
              "role": "modifier"
            }
          ],
          "conditions": [],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "return_home",
          "source_ids": [
            156
          ],
          "name": "Return Home / Homecoming",
          "polarity": "positive",
          "combinations": [
            "2,4,11"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "visa_prospects",
          "source_ids": [
            157
          ],
          "name": "Visa Prospects",
          "polarity": "positive",
          "combinations": [
            "3,11",
            "3,10,11",
            "3,6,11"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [],
          "notes": [
            "Do not state visa approval as guaranteed."
          ]
        },
        {
          "id": "tourist_visa",
          "source_ids": [
            158
          ],
          "name": "Tourist Visa Prospects",
          "polarity": "positive",
          "combinations": [
            "3,5,11"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "study_visa",
          "source_ids": [
            159
          ],
          "name": "Study Visa Prospects",
          "polarity": "positive",
          "combinations": [
            "3,9,12 + 4,9,12"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "business_visa",
          "source_ids": [
            160
          ],
          "name": "Business Visa Prospects",
          "polarity": "positive",
          "combinations": [
            "2,6,10,11",
            "6,11",
            "2,6",
            "10,11"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [
            "Import/export business: +2,7,10,11"
          ],
          "notes": []
        },
        {
          "id": "work_visa",
          "source_ids": [
            161
          ],
          "name": "Work Visa Prospects",
          "polarity": "positive",
          "combinations": [
            "2,6,10,11",
            "6,11",
            "2,6",
            "10,11"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "partner_abroad",
          "source_ids": [
            162
          ],
          "name": "Partner Abroad Indicators",
          "polarity": "neutral",
          "combinations": [
            "Visa combination + 2,7,11"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "marriage_abroad",
          "source_ids": [
            163
          ],
          "name": "Marriage Abroad Prospects",
          "polarity": "positive",
          "combinations": [
            "Visa combination + 2,7,11"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "professional_conference_travel",
          "source_ids": [
            165
          ],
          "name": "Professional / Conference Travel",
          "polarity": "positive",
          "combinations": [
            "3,9,12 + 3,11"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [],
          "notes": []
        },
        {
          "id": "sports_related_travel",
          "source_ids": [
            166
          ],
          "name": "Sports-Related Travel",
          "polarity": "positive",
          "combinations": [
            "3,9,12 + 5,11"
          ],
          "planets": [
            {
              "name": "Sun",
              "role": "modifier"
            }
          ],
          "conditions": [],
          "modifiers": [],
          "notes": []
        }
      ]
    },
    {
      "id": "family_life_development",
      "name": "Family & Life Development",
      "events": [
        {
          "id": "family_expansion",
          "source_ids": [
            147
          ],
          "name": "Family Expansion Prospects",
          "polarity": "positive",
          "combinations": [
            "5,11"
          ],
          "planets": [],
          "conditions": [],
          "modifiers": [],
          "notes": [
            "Keep wording broad and non-medical.",
            "Do not predict pregnancy, pregnancy loss, delivery method, or other medical outcomes."
          ]
        }
      ]
    }
  ],
  "excluded_from_public_schema": [
    "Disease or medical diagnosis predictions",
    "Medication effectiveness or treatment recommendations",
    "Surgery, paralysis, chronic/incurable disease or body-part injury predictions",
    "Death, maraka/badhaka mortality or death-timing predictions",
    "Suicide, self-harm or method-specific self-harm predictions",
    "Pregnancy loss, abortion, infertility, impotence, delivery-method or pregnancy-complication predictions",
    "Murder, sexual assault, kidnapping, terrorism or violent-crime predictions",
    "Prostitution/call-girl/mistress or explicit sexual-behaviour labels",
    "Police arrest, jail or criminal-accusation predictions",
    "Gambling/satta gain or loss predictions",
    "Health problems abroad or medical-treatment-abroad predictions",
    "Election win/loss or public-election outcome predictions"
  ]
};

export default nadiSafeEvents;
